
export const headerData = {
    name: 'SHAHEEDUL ASLAM',
    title: "Hello! I am",
    desciption: "Hello! I am Shaheedul Aslam, a professional and passionate programmer in my daily life. A quick learner with a self-learning attitude. I love to learn and explore new technologies and am Passionate about Problem Solving. ",
    // image: 'https://media.licdn.com/dms/image/D5603AQHwsFXF9zn0CQ/profile-displayphoto-shrink_800_800/0/1676822380986?e=1686787200&v=beta&t=5ov_6s3DSnv30JuAyJz7NAsTuVtEo9OmL1lQocgKQhE',
    image: 'profile-pic.png',
    imagebw: 'profile-pic.png',
    resumePdf: 'https://drive.google.com/file/d/16azA9q-w9xbqVF26x--u1hvW4_U62UOM/view?usp=drive_link'
}
